module.exports = __webpack_public_path__ + "static/media/double-win.b9e936ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/slider-banners/double-win/double-win.png
// module id = 2456
// module chunks = 7